var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-project"},[_c('div',{staticClass:"content-center"},[_c('div',{staticClass:"title"},[_vm._v("更多方案请使用易隆创·解决方案大模型")]),_c('div',{staticClass:"remark"},[_vm._v("对话即可查看方案，赋能每一位云企业老板")])])])
}]

export { render, staticRenderFns }